const config = {
    url: 'https://s3.amazonaws.com/emun-on-demand/fonts/all.json',
    forbiddenFonts: [] //'ABeeZee'
};

export default config;